// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"acda037d","318":"9c796736","357":"627ce7d2","553":"ad85f281","567":"15c39c1b","631":"35e7b769","666":"b75782d9","706":"f7e6d9cc","797":"71e02af8"}[chunkId] + ".chunk.js";
};